export const getReadableTemplateName = (enumName) => {
    const templateNameMap = {
        'SENT_CAMPAIGN_TO_REVIEW_ADMIN': 'Kampanya İnceleme Bildirimi (Admin)',
        'REJECTED_CAMPAIGN_TO_REVIEW': 'Kampanya Reddedildi Bildirimi',
        'SENT_CAMPAIGN_TO_COMMITTEE': 'Kampanya Komiteye Gönderildi Bildirimi',
        'CAMPAIGN_COMMITTEE_APPROVED': 'Kampanya Komite Onayı Bildirimi',
        'CAMPAIGN_FUND_CLOSED': 'Kampanya Fon Toplama Kapatıldı Bildirimi',
        'CAMPAIGN_FUND_SUCCESS': 'Kampanya Fon Toplama Başarılı Bildirimi',
        'CAMPAIGN_FUND_FAILED': 'Kampanya Fon Toplama Başarısız Bildirimi',
        'CAMPAIGN_FUND_SUCCESS_INVESTOR': 'Kampanya Fon Toplama Başarılı Bildirimi (Yatırımcı)',
        'CAMPAIGN_FUND_FAILED_INVESTOR': 'Kampanya Fon Toplama Başarısız Bildirimi (Yatırımcı)',
        'SENT_CAMPAIGN_TO_REVIEW': 'Kampanya İncelemeye Gönderildi Bildirimi',
        'COMMITTEE_APPROVAL': 'Komite Onayı Bildirimi (Yatırım Komitesi Üyesi)',
        'OPENED_CAMPAIGN_PASS_THE_TARGET': 'Kampanya Hedefi Geçildi Bildirimi',
        'OPENED_CAMPAIGN_FELL': 'Kampanya Hedefi Düşürüldü Bildirimi',
        'OPENED_CAMPAIGN_FUND_SUCCESS': 'Kampanya Fon Toplama Başarılı Bildirimi (Açık Kampanya)',
        'OPENED_CAMPAIGN_READY_TO_FINANCIAL_CLOSE': 'Kampanya Finansal Kapatmaya Hazır Bildirimi',
        'OPENED_CAMPAIGN_FAILED': 'Kampanya Başarısız Bildirimi',
        'OPENED_CAMPAIGN_NEW_QUESTION': 'Kampanya Yeni Soru Bildirimi',
        'USER_ACCOUNT_DELETION': 'Kullanıcı Hesabı Silme Bildirimi',
        'PAYMENT_WITHDRAW_REQUEST': 'Ödeme Çekme Talebi Bildirimi',
        'USER_ACCOUNT_DELETION_CANCELED': 'Kullanıcı Hesabı Silme İptal Bildirimi',
        'CAMPAIGN_SENT_TO_APPROVAL': 'Kampanya Onaya Gönderildi Bildirimi',
        'CAMPAIGN_SEND_TO_PRE_REQUEST': 'Kampanya Ön Talebe Gönderildi Bildirimi',
        'CAMPAIGN_SEND_TO_FUNDING': 'Kampanya Fonlamaya Gönderildi Bildirimi',
        'OPENED_CAMPAIGN_REACH_TO_TARGET': 'Kampanya Hedefe Ulaşıldı Bildirimi',
        'PAYMENT_WITHDRAW_SUCCESSFUL': 'Ödeme Çekme Başarılı Bildirimi',
        'WITHDRAWAL_PARTIAL_RETURNED': 'Çekme İşlemi Kısmi İade Bildirimi',
        'INVESTOR_REGISTERED': 'Yatırımcı Kaydı Bildirimi',
        'SUCCESSFUL_PRE_REQUEST': 'Başarılı Ön Talep Bildirimi',
        'SUCCESSFUL_PAYMENT': 'Başarılı Ödeme Bildirimi',
        'CAMPAIGN_INVESTED_PAST_TARGET': 'Kampanya Hedefi Geçildi Bildirimi (Yatırım)',
        'CAMPAIGN_INVESTED_REACHED_TARGET': 'Kampanya Hedefe Ulaşıldı Bildirimi (Yatırım)',
        'INVESTED_CAMPAIGN_FAILED': 'Yatırım Yapılan Kampanya Başarısız Bildirimi',
        'INVESTED_CAMPAIGN_SUCCESSFUL': 'Yatırım Yapılan Kampanya Başarılı Bildirimi',  
        'EFT_CANCELED': 'EFT İptal Bildirimi',
        'EFT_PAYMENT_REQUEST': 'EFT Ödeme Talebi Bildirimi',
        'EFT_CANCEL_REQUEST': 'EFT İptal Talebi Bildirimi',
        'UPDATE_INVESTED_CAMPAIGN': 'Yatırım Yapılan Kampanya Güncelleme Bildirimi',
        'EFT_CANCEL_IS_CANCELED': 'EFT İptali İptal Bildirimi',
        'ENTREPRENEUR_REGISTERED': 'Girişimci Kaydı Bildirimi',
        'CAMPAIGN_SENT_TO_COMMITTEE': 'Kampanya Komiteye Gönderildi Bildirimi',
        'CAMPAIGN_NEED_CORRECTION': 'Kampanya Düzeltme İhtiyacı Bildirimi',
        'CAMPAIGN_REJECTED': 'Kampanya Reddedildi Bildirimi',
        'USER_ACTIVATION': 'Kullanıcı Aktivasyonu Bildirimi',   
        'USER_NEW_PASSWORD': 'Kullanıcı Yeni Şifre Bildirimi'
    };

    return templateNameMap[enumName] || enumName;
}; 